module.exports = __webpack_public_path__ + "img/steps-mobile.a46fa6d8.png";